import React from 'react'

import { Dashboard } from '@components/common/Dashboard/Dashboard'
import { PageLayout } from '@components/common/PageLayout'
import { DashboardBackButton } from '@components/utils'
import { SECTION_NAMES } from '@constants/sectionNames'
import { BaseContent, HeadContent, Subsection, Tag } from '@fourthwall/components'
import { routing } from '@utils/routing'

import type { App } from '../../Apps.types'
import { mapStatusToTagProps } from '../../utils/mapStatusToTagProps'
import * as S from './AppsTwitter.styled'

export type AppsTwitterShopsViewProps = {
  status: App['status']
  productsLink: string
}

export const AppsTwitterShopsView = ({ status, productsLink }: AppsTwitterShopsViewProps) => {
  const renderStatusTag = () => {
    const props = mapStatusToTagProps(status)

    if (!props) return null

    return (
      <div style={{ marginBottom: 20 }}>
        <Tag {...props} size="large" display="inline-flex" />
      </div>
    )
  }

  return (
    <>
      <HeadContent title={SECTION_NAMES.appTwitterShops} />
      <PageLayout size="tiny">
        <Dashboard.Section
          name={SECTION_NAMES.appTwitterShops}
          topContent={<DashboardBackButton label="Apps" to={routing.apps.self} />}
        >
          {renderStatusTag()}

          <div style={{ marginBottom: 48 }}>
            <BaseContent>
              Fourthwall creators can now show off their products on their X (formerly Twitter)
              profiles! It takes just a few minutes to set up.
            </BaseContent>
          </div>

          <Subsection title="Set up instructions">
            <BaseContent>
              <S.List>
                <li>
                  Go to{' '}
                  <a
                    target="_blank"
                    href="https://ads.twitter.com/shopping_manager"
                    rel="noreferrer"
                  >
                    https://ads.twitter.com/shopping_manager
                  </a>
                </li>
                <li>Enter “Fourthwall Products” for your catalog name and press “Save”</li>
                <li>Click “Add products”</li>
                <li>Click “Scheduled feed</li>
                <li>Select “XML” as the Format type</li>
                <li>
                  For URL, enter: <br />
                  <code>{productsLink}</code>
                </li>
                <li>Leave username and password blank</li>
                <li>
                  Set the frequency to “Hourly” and repeat to “4 hours”. Twitter will now update
                  your products once every four hours (if you edit the title/price/photos).
                </li>
                <li>Press “Create” and you’ve now imported all your products!</li>
                <li>
                  Final step: Go to “All products” and choose the products you’d like to show up on
                  your Twitter profile
                </li>
              </S.List>
            </BaseContent>
          </Subsection>
        </Dashboard.Section>
      </PageLayout>
    </>
  )
}
